<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.requisitions'), $t('text.list')]">
        <el-button
          v-if="Permit.canActionsChargeEdition('mmsRequisitionManage')"
          type="success"
          size="mini"
          @click="$router.push('/normal/mms/requisitions/new')"
        >
          + {{ $t("text.create") }}
        </el-button>
      </breadcrumb>
    </div>
    <narrow :narrows="narrows" @narrowSelect="narrowSelect" />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoRemark')"
            size="small"
          />
        </el-form-item>

        <el-form-item
          ><el-input
            v-model.trim="searchForm.dept"
            :placeholder="$t('requisition.dept')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="finishAt"
            :start-placeholder="
              $t('rules.startAt', [$t('requisition.finishAt')])
            "
            :end-placeholder="$t('rules.endAt', [$t('requisition.finishAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('requisition.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <a @click="showRecord(row)">{{ row.serialNo }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="workflowState"
          :title="$t('text.workflowState')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <state-label :state="row.workflowState">{{
              $t("requisitionTypes." + row.workflowState)
            }}</state-label>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dept"
          :title="$t('requisition.dept')"
          min-width="100"
        />

        <vxe-table-column
          field="finishAt"
          :title="$t('requisition.finishAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="120"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="10" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        />

        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        />

        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('mmsRequisitionManage')"
          field="action"
          :title="$t('text.action')"
          width="100"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-popconfirm
              v-if="row.workflowState == 'newly'"
              :title="$t('prompt.confirmDelete')"
              @confirm="deleteRow(row)"
              class="mgl10"
            >
              <el-button slot="reference" type="text" size="mini">
                {{ $t("text.delete") }}
              </el-button>
            </el-popconfirm>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer> -->
    <el-dialog
      :title="$t('text.view')"
      :close-on-click-modal="false"
      :visible.sync="showDF"
      width="80%"
    >
      <show-dialog
        :id="currentRowId"
        @close="showDF = false"
        @updateData="showClose"
      />
    </el-dialog>

    <!-- edit -->
    <el-dialog
      :title="$t('text.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editForm" :model="editObj" label-width="80px">
        <el-form-item
          :label="$t('requisition.dept')"
          :prop="'dept'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('requisition.dept')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.dept" />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="editObj.remark"
            type="textarea"
            :rows="4"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import DateRange from "@/components/DateRange";
// import Show from "./show";
import ShowDialog from "./showDialog";
import Requisition from "@/api/requisition.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    RawHtmlLimitNumber,
    // Show,
    ShowDialog,
  },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("text.workflowState"),
            items: Requisition.workflowStates.map((t) => {
              return {
                key: t,
                label: this.$t("requisitionTypes." + t),
                condition: { workflowState: t },
              };
            }),
          },
        ],
      ],

      initFilter: null,
      searchForm: {
        keyword: null,
        ownerId: null,
      },
      sorter: {
        sortBy: "requisitions_id",
        sortIndicator: "desc",
      },
      //
      currentRowId: null,
      showDF: false,
      // 编辑
      editDF: false,
      row: null,
      editObj: { remark: null, dept: null },
      editDoing: false,
    };
  },

  created() {
    const self = this;
  },
  methods: {
    // 删除
    deleteRow(row) {
      const self = this;
      Requisition.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    edit(row) {
      this.row = row;
      this.editObj.dept = row.dept;
      this.editObj.remark = row.remark;
      this.editDF = true;
    },
    editSubmit() {
      const self = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Requisition.update(self.row.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    showRecord(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    showClose() {
      this.loadData();
    },
    //-----
    dataProvider(params) {
      return Requisition.search(params);
    },
  },
};
</script>
